import { useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const Labs = () => {
    const {university_name,dean_name,department_name} = useParams()
    const navigate = useNavigate()
    const [labs, setLabs] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
       const fetchLabs = async () => {
          try {
            const res = await axios.get(`${BASE_URL}/marketplace/university/labhead/labs`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "x-api-key": process.env.REACT_APP_X_API_KEY,
              },
            });
            // console.log("The labs are:",res)
            setLabs(res?.data || []);
          } catch (error) {
            console.log("Error while getting profiles", error);
            setLabs([]);
          }
        };
      useEffect(() => {
        fetchLabs();
      }, []);
        // Filter departments by department name or dean name
  const filteredLabs = labs.filter((lab) => {
    const labName = lab?.lab_name?.toLowerCase()  || "";
    const search = searchTerm.toLowerCase();
    return labName.includes(search) || labName.includes(search);
  });

  return (
     <div className="p-6">
  <div className="flex items-center gap-3 mb-4">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    </div>
    <div>
  <h1 className="text-2xl  font-bold text-gray-900"> You are the Head of These Labs of {" "}
          <span className="text-blue-900">{university_name}</span>.
           </h1>
  <p className="text-sm text-gray-500 mt-1">Below is the list of your labs in the attached university departments.</p>
</div>

  </div>

  <div className="w-full flex justify-between items-center mb-6">
    <div className="relative w-full">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <input
        type="text"
        placeholder="Search by department or dean name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>
  </div>

  <div className="border border-gray-200 rounded-xl overflow-hidden">
    <table className="min-w-full">
      <thead className="bg-gray-50 border-b border-gray-200">
        <tr>
          {/* New Profile Image Column */}
          <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Lab Name</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Department Name</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">University Name</th>
          {/* <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Department Name</th> */}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {filteredLabs.length > 0 ? (
          filteredLabs.map((dept) => (
            <tr key={dept.id} className="hover:bg-gray-50 transition-colors">
              {/* Profile Image Column */}
              {/* <td className="px-6 py-4">
                <img
                  src={dept?.university_data?.university_logo || "/default-profile.png"}
                  alt={dept?.university_data?.university_name || "Dean"}
                  className="w-10 h-10 rounded-full object-cover"
                />
              </td> */}

              {/* Department Name */}
              {/* <td className="px-6 py-4 text-sm text-gray-900">{id}</td> */}
              <td className="px-6 py-4 text-sm text-gray-900">{dept.lab_name}</td>
               <td className="px-6 py-4 text-sm text-gray-900">{dept.department_name}</td>
               <td className="px-6 py-4 text-sm text-gray-900">{university_name}</td>

              {/* Head of Department */}
               <td className="px-6 py-4">
                <div className="flex gap-2">
                 <button
    //   onClick={() => navigate(`/marketplace/${id}/dean/labhead/add`,{state:{depId:dept?.id}})}
     onClick={() => navigate(`/marketplace/${university_name}/${dean_name}/${department_name}/lab/labhead/lab_group/add`,{state:{labId:dept?.id}})}
      className="flex items-center gap-2 px-4 py-2 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
      Add Lab Group
    </button>
                 
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="3" className="px-6 py-12 text-center">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <p className="text-gray-500">No departments found.</p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>

  )
}

export default Labs
